import Typography, { TypographyProps } from '@mui/material/Typography';

import { LanguageKeys } from 'src/common/constants/languages';
import { getPathForLanguage } from 'src/helpers/publicPageUtils';
import { IPublicPage } from 'src/interfaces/PublicPage';

interface PagePathCaptionProps extends TypographyProps {
  page: IPublicPage;
  lang: LanguageKeys;
  publicPagesById?: Record<string, IPublicPage>;
}

export default function PagePathCaption({
  page,
  lang,
  publicPagesById,
  ...typographyProps
}: PagePathCaptionProps) {
  const fullPath = getPathForLanguage(page, lang, publicPagesById);

  return (
    <Typography variant="caption" color="text.secondary" noWrap component="span" {...typographyProps}>
      {fullPath}
    </Typography>
  );
}
